<template>
  <div class="item-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ItemTitle}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
     <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ItemDetailBase",
    props:{
      ItemTitle:{}
    }
  }
</script>
<style lang="less" scoped>
  .item-base{
    .header{
      height: 44px;
      background: #F6F7F8;
      .header-content{
        line-height: 44px;
        margin: 0 auto;
        width: 74.5%;
        /*padding:10px;*/
      }
    }
    .content{
      width: 74.5vw;
      margin: 0 auto;
      min-height: 82vh;

    }
    .active{
      color: #ffffff;
      height: 35px;
      background: #188ACB;
      border-radius: 20px;
      padding: 3px 10px;
    }
    .page{
      text-align: center;
    }
  }
</style>